@if (supportService.isOpen() && supportService.podeAcessarSuporte()) {
  <div 
    class="support-modal-backdrop"
    (click)="onBackdropClick($event)"
    role="dialog"
    aria-modal="true"
    aria-labelledby="support-modal-title">

    <div class="support-modal-sheet" (click)="$event.stopPropagation()">
      <!-- Handle bar visual para ergonomia em telas mobile -->
      <div class="drag-handle-bar" aria-hidden="true"></div>

      <!-- Header do Modal -->
      <header class="sheet-header">
        <div class="header-top-row">
          <div class="badge-pill" [class.badge-anual]="supportService.isPlanoAnual()" [class.badge-mensal]="supportService.isPlanoMensal()">
            @if (supportService.isPlanoAnual()) {
              <lucide-icon [img]="Sparkles" size="14"></lucide-icon>
              <span>Plano Anual • Ativo</span>
            } @else {
              <lucide-icon [img]="ShieldCheck" size="14"></lucide-icon>
              <span>Plano Mensal • Ativo</span>
            }
          </div>

          <button 
            type="button" 
            class="btn-close-modal" 
            (click)="close()" 
            title="Fechar suporte (Esc)"
            aria-label="Fechar suporte">
            <lucide-icon [img]="X" size="20"></lucide-icon>
          </button>
        </div>

        <div class="header-title-box">
          <div class="header-icon-wrap">
            <lucide-icon [img]="Headphones" size="22"></lucide-icon>
          </div>
          <div>
            <h2 id="support-modal-title" class="sheet-title">Central de Suporte Oficial</h2>
            <p class="sheet-subtitle">
              @if (supportService.isPlanoAnual()) {
                Atendimento prioritário multicanal com equipe de especialistas.
              } @else {
                Atendimento técnico por e-mail para administradores do cerimonial.
              }
            </p>
          </div>
        </div>
      </header>

      <!-- Corpo com Rolagem Suave -->
      <div class="sheet-body-scroll">
        <div class="channels-container">
          
          <!-- Canal 1: E-mail de Suporte (Sempre Visível para Assinantes Ativos) -->
          <article class="channel-card email-card">
            <div class="card-icon-col">
              <div class="channel-icon-badge icon-email">
                <lucide-icon [img]="Mail" size="20"></lucide-icon>
              </div>
            </div>
            <div class="card-content-col">
              <div class="channel-meta-header">
                <span class="channel-tag">Suporte Técnico</span>
                <span class="channel-timing">Até 24h úteis</span>
              </div>
              <h3 class="channel-title">Atendimento via E-mail</h3>
              <p class="channel-address">{{ supportService.config.email }}</p>
              <p class="channel-desc">Dúvidas operacionais, orientações técnicas e solicitações de ajuste.</p>
              <a 
                [href]="'mailto:' + supportService.config.email"
                class="btn-action-channel btn-action-email"
                (click)="close()">
                <lucide-icon [img]="Mail" size="16"></lucide-icon>
                <span>Enviar E-mail</span>
                <lucide-icon [img]="ExternalLink" size="14" class="icon-right"></lucide-icon>
              </a>
            </div>
          </article>

          <!-- Canal 2 (Condicional por Plano) -->
          @if (supportService.isPlanoAnual()) {
            <!-- 🟢 WhatsApp Oficial Prioritário (Plano Anual) -->
            <article class="channel-card whatsapp-card">
              <div class="card-icon-col">
                <div class="channel-icon-badge icon-whatsapp">
                  <lucide-icon [img]="MessageCircle" size="20"></lucide-icon>
                </div>
              </div>
              <div class="card-content-col">
                <div class="channel-meta-header">
                  <span class="channel-tag tag-whatsapp-exclusive">
                    <lucide-icon [img]="Sparkles" size="12"></lucide-icon>
                    Canal Exclusivo Anual
                  </span>
                  <span class="channel-timing timing-fast">Atendimento Ágil</span>
                </div>
                <h3 class="channel-title">WhatsApp Oficial Prioritário</h3>
                <p class="channel-address">{{ supportService.config.whatsappFormatted }}</p>
                <p class="channel-desc">
                  Conversa direta no WhatsApp com mensagem de identificação automática pré-formatada.
                </p>
                <a 
                  [href]="supportService.config.whatsappUrl"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="btn-action-channel btn-action-whatsapp"
                  (click)="close()">
                  <lucide-icon [img]="MessageCircle" size="16"></lucide-icon>
                  <span>Abrir WhatsApp</span>
                  <lucide-icon [img]="ExternalLink" size="14" class="icon-right"></lucide-icon>
                </a>
              </div>
            </article>
          } @else if (supportService.isPlanoMensal()) {
            <!-- ⚡ Gatilho Visual de Upgrade para o Plano Anual (Plano Mensal) -->
            <article class="upsell-card">
              <div class="upsell-badge">
                <lucide-icon [img]="Zap" size="13"></lucide-icon>
                <span>Benefício do Plano Anual</span>
              </div>
              <h3 class="upsell-title">Quer suporte prioritário no WhatsApp?</h3>
              <p class="upsell-desc">
                O atendimento direto via WhatsApp com respostas imediatas é um benefício exclusivo dos clientes do 
                <strong>Plano Anual</strong>. Ao migrar, você ainda garante <strong>2 meses grátis (17% de economia)</strong>.
              </p>
              <button 
                type="button" 
                class="btn-action-upsell"
                (click)="irParaUpgrade()">
                <lucide-icon [img]="Sparkles" size="16"></lucide-icon>
                <span>Fazer Upgrade para o Plano Anual</span>
                <lucide-icon [img]="ArrowRight" size="16" class="icon-right"></lucide-icon>
              </button>
            </article>
          }

        </div>
      </div>

      <!-- Rodapé -->
      <footer class="sheet-footer">
        <button type="button" class="btn-dismiss-modal" (click)="close()">
          <span>Fechar</span>
        </button>
      </footer>
    </div>
  </div>
}
